<template>
  <v-dialog v-model="show" max-width="60%" persistent>
    <v-card class="rounded-lg">
      <v-card-title color="primary" class="primary primary-title">
        <v-icon color="white darken-3">mdi-download</v-icon>
        <span class="white--text title pl-2"> Export Table </span>
      </v-card-title>

      <v-card-text class="pt-4">
        <v-text-field
          ref="vtf"
          v-model="filenamePrefix"
          :rules="[() => !!filenamePrefix || 'Filename is required.']"
          label="Filename"
          text
          clearable
          class="mt-2"
        >
        </v-text-field>

        <v-radio-group
          v-model="fileFormat"
          label="File format:"
          row
          dense
          class="pa-0 pb-2"
        >
          <v-radio key="ff-csv" label="CSV" value="csv"></v-radio>
          <v-radio key="ff-pdf" label="PDF" value="pdf"></v-radio>
        </v-radio-group>

        <v-select
          v-model="pdfFormat"
          :disabled="fileFormat !== 'pdf'"
          dense
          label="PDF page size:"
          :items="pdfFormats"
          item-text="label"
          item-value="value"
        >
        </v-select>

        <v-radio-group
          v-model="pdfOrientation"
          label="PDF orientation:"
          row
          dense
          :disabled="fileFormat !== 'pdf'"
          class="pa-0 ma-0"
        >
          <v-radio
            key="po-portrait"
            label="Portrait"
            value="portrait"
          ></v-radio>
          <v-radio
            key="po-landscape"
            label="Landscape"
            value="landscape"
          ></v-radio>
        </v-radio-group>
      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text color="red lighten-2" @click="close()">
          <v-icon left>close</v-icon> Cancel
        </v-btn>
        <v-btn color="primary" @click="exportTable">Export</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
var PDF_FORMATS = [
  { label: 'Letter', value: 'letter' },
  { label: 'Legal', value: 'legal' },
  { label: 'A4', value: 'a4' },
  { label: 'A3', value: 'a3' },
  { label: 'A2', value: 'a2' },
  { label: 'A1', value: 'a1' },
  { label: 'A0', value: 'a0' },
];

export default {
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    defaultFilenamePrefix: {
      type: String,
      required: false,
      default: 'export',
    },
  },
  data() {
    return {
      filenamePrefix: null,
      fileFormat: 'pdf',
      pdfFormats: PDF_FORMATS,
      pdfFormat: PDF_FORMATS[0].value,
      pdfOrientation: 'portrait',
    };
  },
  watch: {
    defaultFilenamePrefix(dfp) {
      this.filenamePrefix = dfp;
    },
  },
  mounted() {
    this.filenamePrefix = this.defaultFilenamePrefix;
  },
  methods: {
    close() {
      this.$emit('dialogClosed');
    },
    exportTable() {
      this.$emit('exportTable', {
        format: this.fileFormat,
        pagesize: this.pdfFormat,
        orientation: this.pdfOrientation,
        prefix: this.filenamePrefix,
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
